<template>
  <div class="support_search">
    <div class="support_search-block">
      <input 
        :placeholder="$t('Введите текст')"
        class="support_search-block-input"
        v-model="searchText"
      />
      <button 
        @click="sendSearch"
        class="support_search-block-button"
      >
        {{ $t('Поиск') }}
      </button>
        <button 
        @click="clearSearch"
        class="support_search-block-button"
      >
        {{ $t('Очистить') }}
      </button>
    </div>
  </div>  
</template>
<script>
export default {
  name: "SupportSearch",
  data () {
    return {
      searchText: ""
    }
  },
  watch: {
    searchText: {
      handler (val) {
         if (val == '') {
          this.$store.dispatch('searchText', val)
         }
      }
    }
  },
  methods: {
    sendSearch () {
      this.$store.dispatch('searchText', this.searchText)
    },
    clearSearch () {
      this.searchText = ""
      this.sendSearch()
    }
  }
}
</script>
<style lang="scss" scoped>
  .support_search {
    &-block {
      width: 100%;

      &-input {
        width: calc(100% - 210px);
        border: 1px solid #a1a1a1;
        padding: 5px 10px;
        border-right: none;
        outline: none;

        @media (max-width: 500px) {
           width: calc(100% - 100px);
        }
      }

      &-button {
        background-color: #7a9c31;
        padding: 5px 10px;
        width: 100px;
        border: 1px solid #3a7403;
        color: #fff;

        &:last-child {
          margin-left: 10px;

          @media (max-width: 500px) {
            margin-left: 0;
            margin-top: 10px;
            float: right;
          }
        }
      }
    }
  }
</style>